import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AccountBalanceIcon(props: IconProps) {
    return <Icon {...props} iconKey={"account_balance"}/>
}
